export default __webpack_public_path__ + "images/faa5dc5a3a5f1efab92b549ab68c6b4e-canoeing.jpg";